
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
    Ref,
} from "vue";

const columnList: Array<any> = [
    {
        prop: "vin",
        label: "车架号",
        width: 113,
    },
    {
        prop: "model_name",
        label: "品牌车型",
        width: 73,
    },
    {
        prop: "repair_unit_name",
        label: "所属单位",
        width: 113,
    },
    {
        prop: "user_id",
        label: "会员号",
        width: 73,
    },
    {
        prop: "phone",
        label: "手机",
        width: 113,
    },
    // {
    //     prop: "text",
    //     label: "到期类别",
    //     width: 153,
    // }
];
import { Request } from "@/api/request";
import { ElLoading, ElMessage, ElMessageBox } from "element-plus";
import { carDueExport, carManageExport, getConstructors, getOrderCarSelectList, permissionList } from "@/api/http";
export default defineComponent({
    name: "Expire",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["到期提醒"]);

        let pageSize = ref(10),
            currentPage = ref(1),
            loading = ref(false),
            total = ref(0),
            roleList = ref({} as any),
            headClass = inject("headClass"),
            project = ref([]),
            tableData = ref([] as Array<any>),
            screenParameter: Ref<any> = ref({
                date: null,
                start_time: null,
                end_time: null,
                search: null,
                status: null,
            });

        let getTableData = () => {
            loading.value = true;
            let mydata = {
                type: 1,
                role_name: 'customer_expire',
            };
            permissionList(mydata).then((res: any) => {
                roleList.value = res?.content?.list || 0;
            });
            let data: any = {
                ...screenParameter.value,
                page: currentPage.value,
                pagesize: pageSize.value,
            };
            delete data.date;
            Object.keys(data).forEach((key) => {
                if (data[key] == null) {
                    delete data[key];
                }
            });
            Request.axiosInstance({
                url: "adminapi/CustomerService/carDueV2",
                data,
            }).then((res: any) => {
                loading.value = false;
                tableData.value = res?.content?.list || [];
                total.value = res?.content?.total || 0;
            });
        },
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            },
            handle = (id: number) => {
                ElMessageBox.prompt('请输入跟进备注信息', '已处理', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPlaceholder: '请输入备注信息',
                    inputType: 'textarea'
                })
                    .then(({ value }) => {
                        Request.axiosInstance({
                            url: "adminapi/CustomerService/carDueDealV2",
                            data: {
                                id: id,
                                remark: value
                            },
                        }).then((res: any) => {
                            getTableData();
                        });
                    })
                    .catch(() => { });
            },
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });

                carDueExport(screenParameter.value).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                }).catch(() => {
                    loading.close();
                });
            },
            screenChange = (e: string, key: string | null): void => {
                if (key && e) {
                    if (key == 'start_date') {
                        screenParameter.value.start_time = e[0]
                            ? new Date(e[0]).getTime() / 1000
                            : null;
                        screenParameter.value.end_time = e[1]
                            ? new Date(e[1]).getTime() / 1000
                            : null;
                    }

                } else {
                    if (key == 'start_date') {
                        screenParameter.value.start_time = null;
                        screenParameter.value.end_time = null;
                    }
                }
                currentPage.value = 1;
                getTableData();
            };
        // 出单弹窗
        let issueForm = reactive({
            dialog_show: false,
            today: new Date().toLocaleDateString('zh-CN'),
            expire_date: "",
            car_code: "",
            brand: "",
            vin: "",
            phone: "",
            insurance_company: "",
            provider: "",
            issuer: "",
            renewal: "",
            third_party: "",
            commercial_amount: "",
            commercial_insurance: "",
            ci_amount: "",
            ci_rebate_rate: "",
            vehicle_tax: "",
            accident_insurance: "",
            accident_insurance_a: "",
            insurance_commission: "",
            total_insurance: "",
            accident_rebate_shenghui: "",
            company_rebate_shenghui: "",
            rebate_diff: "",
            subsidy: "",
            gift_item: "",
            gift_cost: "",
            remark: "",
            insurance_data: [] as Array<any>,
            staff_data: [] as Array<any>,
        }),
            openIssueDialog = (row: any) => {
                issueForm.dialog_show = true;
                // 预填车辆信息
                issueForm.car_code = row.code || "";
                issueForm.vin = row.vin || "";
                issueForm.brand = row.model_name || "";
                issueForm.phone = row.phone || "";
                // 重置其他字段
                issueForm.expire_date = "";
                issueForm.insurance_company = "";
                issueForm.provider = "";
                issueForm.issuer = "";
                issueForm.renewal = "";
                issueForm.third_party = "";
                issueForm.commercial_amount = "";
                issueForm.commercial_insurance = "";
                issueForm.ci_amount = "";
                issueForm.ci_rebate_rate = "";
                issueForm.vehicle_tax = "";
                issueForm.accident_insurance = "";
                issueForm.accident_insurance_a = "";
                issueForm.insurance_commission = "";
                issueForm.total_insurance = "";
                issueForm.accident_rebate_shenghui = "";
                issueForm.company_rebate_shenghui = "";
                issueForm.rebate_diff = "";
                issueForm.subsidy = "";
                issueForm.gift_item = "";
                issueForm.gift_cost = "";
                issueForm.remark = "";
                // 更新当天日期
                issueForm.today = new Date().toLocaleDateString('zh-CN');
            },
            issueSubmit = () => {
                console.log(issueForm);
            };
        // 战败弹窗
        let defeatForm = reactive({
            dialog_show: false,
            car_code: "",
            expire_text: "",
            reason: "",
        }),
            openDefeatDialog = (row: any) => {
                defeatForm.dialog_show = true;
                defeatForm.car_code = row.code || "";
                defeatForm.expire_text = row.text || "";
                defeatForm.reason = "";
            },
            defeatSubmit = () => {
                if (!defeatForm.reason) {
                    ElMessage.warning("请输入战败原因");
                    return;
                }
                console.log("战败原因:", defeatForm);
                defeatForm.dialog_show = false;
            };
        // 报价弹窗
        let quoteForm = reactive({
            dialog_show: false,
            car_code: "",
            quoter: "",
            content: "",
        }),
            openQuoteDialog = (row: any) => {
                quoteForm.dialog_show = true;
                quoteForm.car_code = row.code || "";
                quoteForm.quoter = "";
                quoteForm.content = "";
            },
            quoteSubmit = () => {
                if (!quoteForm.quoter) { ElMessage.warning("请选择报价人"); return; }
                if (!quoteForm.content) { ElMessage.warning("请输入报价内容"); return; }
                console.log("报价:", quoteForm);
                quoteForm.dialog_show = false;
            };
        // 跟进弹窗
        let followForm = reactive({
            dialog_show: false,
            car_code: "",
            follower: "",
            content: "",
        }),
            openFollowDialog = (row: any) => {
                followForm.dialog_show = true;
                followForm.car_code = row.code || "";
                followForm.follower = "";
                followForm.content = "";
            },
            followSubmit = () => {
                if (!followForm.follower) { ElMessage.warning("请选择跟进人"); return; }
                if (!followForm.content) { ElMessage.warning("请输入跟进内容"); return; }
                console.log("跟进记录:", followForm);
                followForm.dialog_show = false;
            };
        onMounted(() => {
            getTableData();
            Request.axiosInstance({
                url: "adminapi/Project/list",
                data: {
                    status: 1,
                },
            }).then((res: any) => {
                project.value = res?.content?.list || [];
            });
            // 保险公司列表
            getOrderCarSelectList().then((res: any) => {
                if (res.status == 200) {
                    issueForm.insurance_data = res.content.insurance_data || [];
                }
            });
            // 出单员列表
            getConstructors({}).then((res: any) => {
                issueForm.staff_data = res?.content?.staff || [];
            });
        });

        return {
            pageSize,
            currentPage,
            columnList,
            loading,
            tableData,
            project,
            handleSizeChange,
            handleCurrentChange,
            total,
            handle,
            headClass,
            screenChange,
            screenParameter,
            exportChange,
            roleList,
            issueForm,
            openIssueDialog,
            issueSubmit,
            defeatForm,
            openDefeatDialog,
            defeatSubmit,
            followForm,
            openFollowDialog,
            followSubmit,
            quoteForm,
            openQuoteDialog,
            quoteSubmit
        };
    },
});
